import { AdvancedExchangeRecommendationOutputSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/advanced-exchange-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";
export type { AdvancedExchangeRecommendationOutput } from "@redotech/redo-model/agents/returns-agents/exchange-agent/advanced-exchange-recommendation";

export const getAdvancedExchangeRecommendation = unaryRpc({
  name: "getAdvancedExchangeRecommendation" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    otherProductsBeingReturned: z.array(ReturnProductSchema).optional(),
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: AdvancedExchangeRecommendationOutputSchema,
});
